/* eslint-disable */
/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Produced by `node scripts/gen-palettes.mjs`. Change the curves or the family
 * parameters in that script and re-run it; a hand edit here will be reverted by the
 * next run and is caught by `node scripts/gen-palettes.mjs --check`.
 */

/** Steps of an accent ramp. 700 is the light-mode anchor, 400 the dark-mode one. */
export type RampStep =
  | "50" | "100" | "200" | "300" | "400" | "500"
  | "600" | "700" | "800" | "900" | "950";

/** Steps of a tinted neutral ramp. `n*` are shared/light-mode, `d*` are dark-mode text. */
export type NeutralStep =
  | "n0" | "n50" | "n100" | "n200" | "n300" | "n500" | "n600" | "n700"
  | "n750" | "n800" | "n850" | "n880" | "n900"
  | "d100" | "d200" | "d300";

/** Families that are generated. Slate keeps its hand-tuned values and is not in here. */
export type GeneratedFamily = "turquoise" | "cyan" | "teal";

export type AccentRamp = Record<RampStep, string>;
export type NeutralRamp = Record<NeutralStep, string>;

export const ACCENT_RAMPS: Record<GeneratedFamily, AccentRamp> = {
  turquoise: {
    "50": "#EEFBF7",
    "100": "#DBF6EE",
    "200": "#B8EBDE",
    "300": "#8EDBCB",
    "400": "#5EC5B3",
    "500": "#2AAE9C",
    "600": "#049485",
    "700": "#007A6F",
    "800": "#02625A",
    "900": "#00504A",
    "950": "#012D2A",
  },
  cyan: {
    "50": "#F0F9FF",
    "100": "#DDF2FF",
    "200": "#BBE5FD",
    "300": "#95D4F6",
    "400": "#69BCE4",
    "500": "#3FA4D0",
    "600": "#1E8BB4",
    "700": "#0E7395",
    "800": "#075D78",
    "900": "#054C62",
    "950": "#012B38",
  },
  teal: {
    "50": "#F0FAFA",
    "100": "#DEF3F4",
    "200": "#C0E7E9",
    "300": "#9CD6DA",
    "400": "#75BFC4",
    "500": "#52A7AE",
    "600": "#398E95",
    "700": "#2B757C",
    "800": "#215E65",
    "900": "#1B4D52",
    "950": "#0B2B2F",
  },
};

export const NEUTRAL_RAMPS: Record<GeneratedFamily, NeutralRamp> = {
  turquoise: {
    n0: "#F7FBFA",
    n50: "#FFFFFF",
    n100: "#F2F7F6",
    n200: "#E0E8E7",
    n300: "#CDD7D5",
    n500: "#727D7B",
    n600: "#535D5C",
    n700: "#232E2C",
    n750: "#212D2B",
    n800: "#182321",
    n850: "#0E1817",
    n880: "#08201D",
    n900: "#051815",
    d100: "#838F8D",
    d200: "#9CA7A5",
    d300: "#E1EAE8",
  },
  cyan: {
    n0: "#F7FBFC",
    n50: "#FFFFFF",
    n100: "#F2F7F9",
    n200: "#E0E7EB",
    n300: "#CDD6DA",
    n500: "#727C81",
    n600: "#535D61",
    n700: "#232D32",
    n750: "#222C30",
    n800: "#192226",
    n850: "#0E181C",
    n880: "#0A1E26",
    n900: "#06161D",
    d100: "#848E93",
    d200: "#9DA6AB",
    d300: "#E1E9ED",
  },
  teal: {
    n0: "#F7FBFB",
    n50: "#FFFFFF",
    n100: "#F1F7F8",
    n200: "#E0E8E9",
    n300: "#CCD6D7",
    n500: "#717D7E",
    n600: "#525D5E",
    n700: "#222E2F",
    n750: "#212D2E",
    n800: "#172324",
    n850: "#0D1819",
    n880: "#071F21",
    n900: "#041719",
    d100: "#838F90",
    d200: "#9CA7A8",
    d300: "#E1EAEB",
  },
};

/** Clinical modules of the departmental theme. Ordered warm to cool, as the hue wheel runs. */
export type ModuleKey =
  | "billing" | "pharmacy" | "radiology" | "administration" | "op" | "lab" | "ip";

/** Same 11 steps, same lightness curve — so every module's 700 weighs the same as every other. */
export const MODULE_RAMPS: Record<ModuleKey, AccentRamp> = {
  billing: {
    "50": "#FEF5F1",
    "100": "#FFEADF",
    "200": "#FFD4BE",
    "300": "#FEB793",
    "400": "#F19666",
    "500": "#DD7940",
    "600": "#C26126",
    "700": "#A24E19",
    "800": "#843E11",
    "900": "#6C310D",
    "950": "#3F1A04",
  },
  pharmacy: {
    "50": "#EDFCF3",
    "100": "#D8F7E5",
    "200": "#B5EECD",
    "300": "#8CDFB1",
    "400": "#5FC893",
    "500": "#35B178",
    "600": "#199762",
    "700": "#157C50",
    "800": "#156441",
    "900": "#145135",
    "950": "#092E1C",
  },
  radiology: {
    "50": "#EEFAFF",
    "100": "#D9F4FE",
    "200": "#AEE9FF",
    "300": "#82D8F6",
    "400": "#52BFE3",
    "500": "#23A7CD",
    "600": "#028DB0",
    "700": "#0C7490",
    "800": "#145D73",
    "900": "#164C5D",
    "950": "#0B2A34",
  },
  administration: {
    "50": "#F7F7F8",
    "100": "#ECEFF1",
    "200": "#D8DFE6",
    "300": "#BECCD9",
    "400": "#9DB3C8",
    "500": "#7E9BB7",
    "600": "#6283A3",
    "700": "#4B6C8C",
    "800": "#385775",
    "900": "#2A4762",
    "950": "#13283B",
  },
  op: {
    "50": "#F6F7FB",
    "100": "#E8EFFC",
    "200": "#CFDEFF",
    "300": "#B2C9FE",
    "400": "#8CAEFE",
    "500": "#6691FF",
    "600": "#4472FA",
    "700": "#2F59DF",
    "800": "#2043C1",
    "900": "#1531A8",
    "950": "#07166A",
  },
  lab: {
    "50": "#F7F7FD",
    "100": "#EDECFE",
    "200": "#DCD9FF",
    "300": "#C7C2FE",
    "400": "#ACA2FF",
    "500": "#9581FE",
    "600": "#805BFB",
    "700": "#6A41DF",
    "800": "#572BBF",
    "900": "#481AA5",
    "950": "#290368",
  },
  ip: {
    "50": "#FAF6FB",
    "100": "#F7E9F8",
    "200": "#F0D2F5",
    "300": "#E9B5F0",
    "400": "#DA90E6",
    "500": "#CB6BDA",
    "600": "#B549C6",
    "700": "#9B2FAC",
    "800": "#821A91",
    "900": "#6D067B",
    "950": "#40004A",
  },
};
